// Separa a linha de endereço já extraída pelo fatura-parser (cabecalho.end_logradouro)
// nos componentes que o CRM precisa (número/complemento/quadra/lote) — convenção de
// loteamento comum em Goiás: "RUA X, Q. 64, L. 08, S/N, CASA - 02". Não é parte do
// fatura-parser em si: opera sobre o texto JÁ concatenado (ele mesmo é um join(', ')
// de linhas OCR, ver secoes.ts), então um split por vírgula basta — sem geometria.

export interface EnderecoGoias {
  logradouro: string;
  numero: string;
  complemento: string;
  quadra: string;
  lote: string;
}

const RE_QUADRA = /^Q(?:D[A]?|UADRA)?\.?\s*([A-Z0-9][A-Z0-9\-\/]*)$/i;
const RE_LOTE = /^L(?:T|OTE)?\.?\s*([A-Z0-9][A-Z0-9\-\/]*)$/i;
const RE_SN = /^S\s*\/?\s*N\.?$/i;
const RE_NUMERO = /^(?:N[ºO°]?\.?\s*)?(\d+[A-Z]?)$/i;
const RE_COMPLEMENTO_PREFIX =
  /^(CASA|APT?O?\.?|APARTAMENTO|BLOCO|BL\.?|SALA|LOJA|FUNDOS|FRENTE|ANDAR|T[ÉE]RREO|SOBRADO|KM|GALP[ÃA]O)\b/i;

/** Nunca lança exceção e nunca descarta texto: segmento não reconhecido antes da 1ª
 *  estrutura encontrada (Q./L./número/complemento) volta pro logradouro (rua com
 *  vírgula própria); depois da 1ª estrutura, cai em complemento. */
export function splitEnderecoGoias(raw?: string | null): EnderecoGoias {
  const result: EnderecoGoias = { logradouro: '', numero: '', complemento: '', quadra: '', lote: '' };
  const text = (raw || '').trim();
  if (!text) return result;

  const segmentos = text.split(',').map((s) => s.trim()).filter(Boolean);
  if (!segmentos.length) return result;

  result.logradouro = segmentos[0];

  let estruturaEncontrada = false;
  const complementos: string[] = [];

  for (let i = 1; i < segmentos.length; i++) {
    const seg = segmentos[i];
    let m: RegExpExecArray | null;

    if ((m = RE_QUADRA.exec(seg))) {
      if (!result.quadra) result.quadra = m[1].toUpperCase();
      estruturaEncontrada = true;
      continue;
    }
    if ((m = RE_LOTE.exec(seg))) {
      if (!result.lote) result.lote = m[1].toUpperCase();
      estruturaEncontrada = true;
      continue;
    }
    if (RE_SN.test(seg)) {
      if (!result.numero) result.numero = 'S/N';
      estruturaEncontrada = true;
      continue;
    }
    if ((m = RE_NUMERO.exec(seg))) {
      if (!result.numero) result.numero = m[1].toUpperCase();
      estruturaEncontrada = true;
      continue;
    }
    if (RE_COMPLEMENTO_PREFIX.test(seg)) {
      complementos.push(seg);
      estruturaEncontrada = true;
      continue;
    }

    if (!estruturaEncontrada) result.logradouro += `, ${seg}`;
    else complementos.push(seg);
  }

  result.complemento = complementos.join('; ');
  return result;
}
